import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/button';
import { Seo } from '../components/seo';
import { InputField } from '../components/input-field';
import { KitRegistrationInput } from '../services/auth/types';
import { axiosInstance, stringifyAxiosError } from '../utils/axios-utils';
import { useCheckoutStore } from '../store/checkout-store';
import { ErrorMessage } from '../components/error-message';

interface FormPartProps<T> {
  onSubmit: { (data: T): Promise<void> };
  mainFormValues: T;
}

const KitRegistration: React.FC<FormPartProps<KitRegistrationInput>> = ({
  onSubmit,
  mainFormValues,
}) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      uniqueId: mainFormValues.uniqueId,
    },
  });
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<string>('');

  const submit = async (data: any) => {
    setErrorMsg('');

    try {
      // validate kit here
      await axiosInstance({
        method: 'POST',
        url: 'kits/validate',
        data,
      });
      sessionStorage.setItem('uniqueId', data.uniqueId);
      await onSubmit(data);
      navigate('/register-kit/sign-up');
    } catch (err: any) {
      setErrorMsg(stringifyAxiosError(err));
      sessionStorage.removeItem('uniqueId');
    }
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <fieldset>
        <div className="flex flex-col gap-10">
          <div>
            {errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}
            <div className="flex flex-col gap-5">
              <p>Enter your Kit ID below:</p>
              <InputField
                label="Kit ID"
                type="text"
                {...register('uniqueId')}
              />
            </div>
          </div>
          <Button
            className="md:flex-[5] flex-[2]"
            type="submit"
            loading={isSubmitting}
          >
            <span>Register Kit</span>
          </Button>
        </div>
      </fieldset>
    </form>
  );
};

function RegisterKitPage() {
  const setSlug = useCheckoutStore((state) => state.setSlug);
  const { watch } = useForm<KitRegistrationInput>();
  const formData = watch();

  useEffect(() => {
    localStorage.removeItem('customerAuthState');
    sessionStorage.removeItem('uniqueId');
  }, [setSlug]);

  return (
    <>
      <Seo title="Sign Up" />
      <h2 className="font-inter font-bold text-[2rem] text-black">
        Register Kit
      </h2>
      <div className="mt-9 max-w-[672px]">
        <div className="mt-[2.875rem]">
          <KitRegistration
            mainFormValues={formData}
            onSubmit={async () => {
              //
            }}
          />
        </div>
      </div>
    </>
  );
}

export default RegisterKitPage;
